import { IconButtonAnimate } from "minimals-template/components/animate"
import Iconify from "minimals-template/components/Iconify"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_SIDE_NAV_REDESIGN } from "routes/@layouts/app/navbar/feature-flag-side-nav-redesign.runtime"

export function MobileNavToggle({ onOpenSidebar, isOpenSidebar = false, legacyLabel, sx, ...props }) {
    const redesign = isEnabled(FEATURE_FLAG_SIDE_NAV_REDESIGN)

    return (
        <IconButtonAnimate
            onClick={onOpenSidebar}
            {...props}
            aria-label={redesign ? "Open Navigation" : legacyLabel}
            aria-expanded={redesign ? isOpenSidebar : undefined}
            sx={{ mr: 1, color: "text.primary", ...sx }}
        >
            <Iconify icon="eva:menu-2-fill" />
        </IconButtonAnimate>
    )
}
